import { Box, Button, Checkbox, CircularProgress, Divider, FormControlLabel, Grid, TextField, Typography } from '@mui/material'

import React, { useEffect, useState } from 'react'
import { useLocation, useNavigate } from 'react-router-dom';
import { toast } from 'react-toastify';
import apiClient from '../../utils/apiClient';

const AddEditReferalConfig = () => {
    const location = useLocation();
    const referal = location?.state?.referal || {};
    const navigate = useNavigate()

    const [formData, setFormData] = useState({
        id: "",
        description: "",
        image: null,
        isActive: true,
        isDeleted: false,
        bonusAmount: 0,
    })
    const [imagePreview, setImagePreview] = useState(null);
    const [error, setError] = useState('');
    const [loading, setLoading] = useState(false);
    const [validateErrors, setValidateErrors] = useState({})


    useEffect(() => {
        if (referal) {
            setFormData({
                id: referal.id || "",
                description: referal.description || "",
                isActive: referal.isActive ?? true,
                isDeleted: referal.isDeleted || false,
                bonusAmount: referal.bonusAmount || 0,
            });

            // Set image preview if available
            if (referal.imageUrl && typeof referal.imageUrl === 'string') {
                setImagePreview(referal.imageUrl);
            } else if (referal.imageUrl) {
                setImagePreview(referal.imageUrl);
            }
        }
    }, [referal]);

    const handleInputChange = (e) => {
        const { name, value } = e.target;


        setFormData(prev => ({ ...prev, [name]: value }));
        setValidateErrors(prev => ({ ...prev, [name]: '' }));


        setError('');
    };

    const handleCheckboxChange = (e) => {
        const { name, checked } = e.target;
        setFormData((prev) => ({
            ...prev,
            [name]: checked,
        }));
    };
    const handleImageFileChange = (e) => {
        const file = e.target.files[0];
        if (file) {
            setFormData((prev) => ({ ...prev, image: file }));
            setImagePreview(URL.createObjectURL(file));
            setValidateErrors(prev => ({ ...prev, image: '' }));
            setError('');
        }
    };

    const validateForm = () => {
        const errors = {};

        if (!formData.description?.trim()) {
            errors.description = "Description is required";
        }
        if (!formData.image && !imagePreview) {
            errors.image = "Image is required";
        }
        if (formData.bonusAmount === '' || isNaN(formData.bonusAmount)) {
            errors.bonusAmount = "Valid bonus amount is required";
        } else if (formData.bonusAmount < 0) {
            errors.bonusAmount = "Bonus amount cannot be negative";
        }

        return errors;
    };

    const handleSubmit = async (e) => {
        e.preventDefault();

        const errors = validateForm();
        if (Object.keys(errors).length > 0) {
            setValidateErrors(errors);
            return;
        }

        setLoading(true);

        try {
            const payload = new FormData();
            if (formData.id) payload.append('id', formData.id);

            payload.append('description', formData.description);
            payload.append('isActive', formData.isActive);
            payload.append('isDeleted', formData.isDeleted);
            payload.append('bonusAmount', formData.bonusAmount);

            if (formData.image instanceof File) {
                payload.append('image', formData.image);
            } else if (typeof imagePreview === 'string') {
                payload.append('image', imagePreview);
            }

            const isEditMode = !!formData.id;

            // const response = isEditMode
            //     ? await axios.put(`${apiUrl}/referralconfig/updatereferralconfig`, payload)
            //     : "";
const response = isEditMode
  ? await apiClient.put(
      `/referralconfig/updatereferralconfig/${formData.id}`,
      payload,
      {
        headers: {
          'Content-Type': 'multipart/form-data',
        },
      }
    )
  : null;

            if (response?.data?.status === true) {
                navigate(-1);
                toast.success(response?.data?.message || 'Operation successful');
            }
        } catch (error) {
            setError(error?.response?.data?.message || 'Something went wrong. Please try again later.');
        } finally {
            setLoading(false);
        }
    };

    return (
        <>
            <Box sx={{ backgroundColor: '', padding: 3 }}>
                <Typography variant="h4" sx={{ mb: 3 }}>
                    Add/Edit Referral Config
                </Typography>
                <Divider sx={{ marginBottom: 3 }} />
                {/* Add your form or content here */}

                <form onSubmit={handleSubmit}>
                    <Grid container spacing={2}>

                        {/* Image Upload */}
                        <Grid item size={12}>
                            <Typography variant="body1" fontWeight={500} gutterBottom>
                                Upload Image
                            </Typography>
                            <Box
                                sx={{
                                    width: 120,
                                    height: 120,
                                    borderRadius: 2,
                                    bgcolor: 'primary.background',
                                    display: 'flex',
                                    alignItems: 'center',
                                    justifyContent: 'center',
                                    border: validateErrors.image ? '1px solid red' : '1px dashed gray',
                                    mb: 1,
                                }}
                            >
                                {imagePreview ? (
                                    <img
                                        src={imagePreview}
                                        alt="Preview"
                                        style={{ width: '110px', height: '110px', borderRadius: 4 }}
                                    />
                                ) : (
                                    <Typography variant="caption">No Image</Typography>
                                )}
                            </Box>
                            <label htmlFor="upload-img">
                                <input
                                    type="file"
                                    id="upload-img"
                                    hidden
                                    accept="image/*"
                                    onChange={handleImageFileChange}
                                />
                                <Button variant="outlined" component="span" type="button">
                                    Upload Image
                                </Button>
                            </label>
                            {validateErrors.image && (
                                <Typography color="error" variant="caption">
                                    {validateErrors.image}
                                </Typography>
                            )}
                        </Grid>

                        {/* Description */}
                        <Grid item size={{ xs: 12, sm: 6 }}>
                            <TextField
                                label="Description"
                                name="description"
                                fullWidth
                                size="small"
                                value={formData.description}
                                onChange={handleInputChange}
                                error={!!validateErrors.description}
                                helperText={validateErrors.description}
                            />
                        </Grid>

                        {/* Bonus Amount */}
                        <Grid item size={{ xs: 12, sm: 6 }}>
                            <TextField
                                label="Bonus Amount"
                                name="bonusAmount"
                                fullWidth
                                size="small"
                                type="number"
                                value={formData.bonusAmount}
                                onChange={handleInputChange}
                                error={!!validateErrors.bonusAmount}
                                helperText={validateErrors.bonusAmount}
                            />
                        </Grid>

                        {/* Checkboxes */}
                        <Grid item size={12}>
                            <FormControlLabel
                                control={
                                    <Checkbox
                                        name="isActive"
                                        checked={formData.isActive}
                                        onChange={handleCheckboxChange}
                                        size="small"
                                    />
                                }
                                label="Is Active"
                            />
                        </Grid>

                        {/* Error Message */}
                        {error && (
                            <Grid item size={12}>
                                <Typography color="error">{error}</Typography>
                            </Grid>
                        )}

                        {/* Submit Button */}
                        <Grid item size={12}>
                            <Box display="flex" justifyContent="end" mt={2} gap={2}>
                                <Button variant="outlined" color="primary" onClick={() => navigate(-1)}>
                                    Cancel
                                </Button>
                                <Button type="submit" variant="contained" disabled={loading}>
                                    {loading ? (
                                        <CircularProgress size={24} sx={{ color: '#fff' }} />
                                    ) : (
                                        'Update'
                                    )}
                                </Button>
                            </Box>
                        </Grid>
                    </Grid>
                </form>


            </Box>

        </>
    )
}

export default AddEditReferalConfig
